<template>
    <div class="modal fade in" 
        tabindex="-1" 
        ref="modal" 
        role="dialog" 
        id="cardTokenModal" 
        data-backdrop="false"
        v-show="showModalIn"
        :class="{cardModalVisible : showModalIn}"
        transition="expand"
        aria-hidden="true"
        aria-labelledby="cardTokenModal"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="handleshowModal(false)">&times;</button>
                </div>

                <div class="modal-body text-center" v-if="step == 1">
                    <h2 v-html="t.Twofa_authentication_two_factor"></h2>
                    <p v-html="t.Twofa_title_1"></p>
                    <div class="image">
                        <img src="/internacional/public/2fa/ic-shield-error.png" v-if="type == 'enable'" />
                        <img src="/internacional/public/2fa/ic-shield-success.png" v-else />
                    </div>
                    <p>{{type == 'enable' ? t.Twofa_text_1 : t.label_2fa_disable_text }}</p>
                    <div class="box__button">
                        <a class="btn__handler"  @click="handleStep()">{{type == 'enable' ? t.btnenable : t.btndisable }}</a>
                    </div>
                </div>
                <div class="modal-body text-center" v-if="step == 2">
                    <!-- <h2>{{type == 'enable' ? t.Twofa_authentication_two_factor : t.Twofa_authentication_two_factor_disable }}</h2> -->
                    <h2>{{t.Twofa_authentication_two_factor}}</h2>
                    <div class="micro__shield">
                        <p v-html="t.Twofa_focus_camera" v-if="type == 'enable'"></p>
                        <img src="/internacional/public/2fa/ic-shield-error.png" v-if="type == 'enable'" />
                        <img src="/internacional/public/2fa/ic-shield-success.png" v-else />
                    </div>
                    <div class="image">
                        <img :src="url2FA" v-if="type == 'enable'" />
                    </div>
                    <div>
                        <h4 v-html="t.Twofa_type_token"></h4>
                    </div>
                    <div class="inputs">
                        <input class="input input-1" type="tel" maxlength="1" v-model="input1" ref="input1" @keyup="handleKeyUpCode(input1, $refs.input1, $refs.input2, $refs.input1)" />
                        <input class="input input-2" type="tel" maxlength="1" v-model="input2" ref="input2" @keyup="handleKeyUpCode(input2, $refs.input2, $refs.input3, $refs.input1)" />
                        <input class="input input-3" type="tel" maxlength="1" v-model="input3" ref="input3" @keyup="handleKeyUpCode(input3, $refs.input3, $refs.input4, $refs.input2)" />
                        <input class="input input-4" type="tel" maxlength="1" v-model="input4" ref="input4" @keyup="handleKeyUpCode(input4, $refs.input4, $refs.input5, $refs.input3)" />
                        <input class="input input-5" type="tel" maxlength="1" v-model="input5" ref="input5" @keyup="handleKeyUpCode(input5, $refs.input5, $refs.input6, $refs.input4)" />
                        <input class="input input-6" type="tel" maxlength="1" v-model="input6" ref="input6" @keyup="handleKeyUpCode(input6, $refs.input6, $refs.btnSend, $refs.input5)"/>
                    </div>
                    <div class="error_code">
                        <span v-if="errorCode" v-html="t.Twofa_invalid_code"></span>
                    </div>
                    <div class="box__button">
                        <button class="btn__handler" @click="handleCheckCreateToken()" ref="btnSend" v-html="t.Twofa_send_code"></button>
                    </div>
                </div>
                <div class="modal-body text-center" v-if="step == 3">
                    <h2>{{t.Twofa_authentication_two_factor}}</h2>
                    <div class="micro__shield">
                        <p style="margin: 1rem 0;" v-if="type == 'enable'">
                            <span v-html="t.Twofa_authentication_factor_is"></span>
                            <b style="color: #35AF2B; text-transform: uppercase;" v-html="t.enable"></b>
                        </p>
                        <p style="margin: 1rem 0;" v-else>
                            <span v-html="t.Twofa_authentication_factor_is"></span>
                            <b style="color: #F86570; text-transform: uppercase;" v-html="t.disable"></b>
                        </p>
                        <div class="double__image" v-if="type == 'enable'" >
                            <img src="/internacional/public/2fa/ic-shield-success.png" />
                            <img src="/internacional/public/2fa/ic-success.png" />
                        </div>
                        <div class="double__image" v-else >
                            <img src="/internacional/public/2fa/ic-shield-error.png" />
                            <img src="/internacional/public/2fa/ic-error.png" />
                        </div>
                    </div>
                    <div class="box__button">
                        <a class="btn__handler" @click="handleFinish()" v-html="t.Twofa_finish"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// HOW TO USE -- need to update

// 1 - add the snippet in the html
// <div id="app__2fa">
//     <create-token-2fa></create-token-2fa>
// </div>

// get the item with id = #token__number OR name = token__number and use the value in your request form

export default {
    props: ["view"],
    name: "create-token-2fa",
    data() {
        return {
            showModalIn: true,
            step: 1,
            url2FA: '',
            loading: false,
            tokenInput: null,
            errorCode: false,
            type: 'create',
            t: window.office.translate,
            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            input6: '',
        };
    },
    methods: {
        handleImage() {
            let vm = this;
            vm.loading = true;
            axios
                .get(window.__env.route_token_2fa_get)
                .then(function(resposta) {
                    vm.url2FA = resposta.data.url;
                })
                .finally(function() {
                    vm.loading = false;
                });
        },
        handleshowModal(type = true) {
            this.showModalIn = type;
        },
        handleCheckCreateToken() {
            let vm = this;
            let valInput = this.input1 + this.input2 + this.input3 + this.input4 + this.input5 + this.input6;

            let url = `${window.__env.route_token_2fa_check}?token=${valInput}&isFirstTime=${valInput}`;
            if(this.type == 'disable') url = `${window.__env.route_token_2fa_check}?token=${valInput}&isToDisable=true`;

            axios.post(url)
            .then(({data}) => {
                if(data.success) {
                    vm.step++;
                } else {
                    vm.errorCode = true;
                }
            })
        },
        handleKeyUpCode(vModel, el, nextEl, befEl) {
            if(el.value >= 0 && el.value <= 9 && el.value != "") {
                this.vModel = el.value;
                nextEl.focus();
            }
            if(event.key == "Backspace" || event.key == "Delete") {
                this.vModel = "";
                befEl.focus();
            }
        },
        handleFinish() {
            window.location.replace(window.__env.route_edit_user);
        },
        handleStep() {
            this.step++;
            if(this.step == 2) {
                setTimeout(() => {
                    this.$refs.input1.focus();
                }, 50);
            }
        },
    },
    
    mounted() {
        this.handleImage();
        this.type = this.view;
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// @import "../../../scss/office";
    .cardModalVisible {
        display: block !important;
        background: rgba(0,0,0,0.5);
    }
    .modal-content {
        border-radius: 20px;
        background: #F3F7FF;
        h2,
        p {
            font-family: 'Muli-Bold';
            text-align: left;
        }
        h2 {
            margin: 0 0 1rem 0;
        }
        .image img {
            height: 160px;
            margin: 2rem 0;
        }
        .box__button {
            display: flex;
            justify-content: flex-end;
            .btn__handler {
                background: #0080FC;
                border: none;
                border-radius: 5px;
                padding: 1rem 3rem;
                color: white;
                text-transform: uppercase;
            }
        }
        .micro__shield {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            img {
                height: 50px;
                width: auto;
            }
            .double__image {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 1rem;
            }
        }
        .inputs {
            display: flex;
            justify-content: center;
            margin-bottom: 1rem;
            input {
                text-align: center;
                font-size: 19px;
                font-weight: bold;
                border: 1px solid #DDDDDD;
                width: 40px;
                height: 50px;
                margin: 0 .1rem;
            }
        }
        .error_code {
            margin-bottom: 1rem;
            span {
                color: #FA4B57;
                font-size: 13px;
                font-weight: bold;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/token-2fa/create-token.vue